export const HolistiplanHowItWorks: React.FC = () => {
  return (
    <div>
      <ul>
        <li>Create new or link to contacts in Holistiplan from your meetings, emails and documents</li>
        <li>Prepare for meetings using combined data from Zocks, Holistiplan, and your connected systems.</li>
        <li>Get instant insights from Holistiplan when using Zocks’ Ask Anything AI Assistant</li>
        <li>Generate email replies based on Holistiplan tax planning data</li>
        <li>Fill Zocks Forms utilizing tax planning data from Holistiplan</li>
      </ul>
    </div>
  )
}
